import { useTranslation } from 'react-i18next'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

const CoreFooter = () => {
    const { t } = useTranslation()

    return (
        <StyledContainer>
            <StyledTypography>{t('LABEL.MAP.FOOTER.COPYRIGHT')}</StyledTypography>
        </StyledContainer>
    )
}

export default CoreFooter

const StyledContainer = styled('div')(({ theme }) => ({
    width: '100%',
    height: '22px',
    bottom: '0px',
    marginTop: '-22px',
    padding: '0 32px',
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
    justifyContent: 'flex-end',
    backgroundColor: '#1C52A3E5 !important',
}))

const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: '11px',
    marginRight: '74px',
    [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
    },
}))
